import * as types from './mutation-types'

export const loadAccompaniments = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/accompaniments', data).then((response) => {
            commit(types.ADD_ACCOMPANIMENTS, response.data.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateAccompaniment = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/' + data.id + '/accompaniment', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const createAccompaniment = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/accompaniment', data).then((response) => {
            commit(types.ADD_ACCOMPANIMENT, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}



export const deleteAccompaniment = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/' + id + '/accompaniment').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

